import { createContext, useContext } from 'react';

import type { PosItem } from '../api/usePosItemsSearch';
import type { PosSaleLine } from '../types';

export interface PosCartContextValue {
  lines: PosSaleLine[];
  addItem: (item: PosItem) => void;
  updateQuantity: (lineKey: string, quantity: number) => void;
  removeLine: (lineKey: string) => void;
  updateProfessional: (lineKey: string, professionalId: number | null) => void;
  updateVariant: (lineKey: string, variantId: number | null) => void;
  updateNotes: (lineKey: string, notes: string) => void;
  updateSubscriptionUsage: (
    lineKey: string,
    payload: Partial<{
      useSubscription: boolean;
      subscriptionId: number | null;
      subscriptionAvailable: number | null;
      subscriptionUnlimited: boolean;
      subscriptionName: string | null;
    }>,
  ) => void;
}

const PosCartContext = createContext<PosCartContextValue | null>(null);

export const PosCartProvider = PosCartContext.Provider;

export const useOptionalPosCart = (): PosCartContextValue | null => {
  return useContext(PosCartContext);
};

export const usePosCart = (): PosCartContextValue => {
  const context = useOptionalPosCart();
  if (!context) {
    throw new Error('usePosCart debe usarse dentro de un PosCartProvider');
  }
  return context;
};

export default PosCartContext;
